import { Flag } from "@alch/dx-entities";
import { useFlag } from "./useFlag";

export const useIsPAYGTierActive = (): boolean => !!useFlag(Flag.PAYGTier).data;
